module.exports = __webpack_public_path__ + "img/20200507_135845.3aec6371.jpg";